import { createSlice } from "@reduxjs/toolkit";
import {
  createDisputeHierarchyThunk,
  deleteDisputeHierarchyThunk,
  fetchDisputeCommentsThunk,
  fetchDisputeHierarchyAsync,
  fetchDisputeHierarchyThunk,
  getAllDisputesThunk,
  getAllRaisedDisputesThunk,
  postDisputeCommentThunk,
  submitDisputeThunk,
  updateDisputeHierarchyThunk,
} from "../thunks/disputeThunks";

const initialState = {
  disputes: null,
  raisedDisputes: null,
  loading: false,
  error: null,
  submitSuccess: false,
  comments: [],
  commentsLoading: false,
  commentsError: null,
  disputeHierarchyData: null,
  disputeHierarchy: null, // for resticting to raised dispute if hierarchy is not set
};

const disputeSlice = createSlice({
  name: "dispute",
  initialState,
  reducers: {
    resetSubmitSuccess(state) {
      state.submitSuccess = false;
    },
    resetComments(state) {
      state.comments = [];
      state.commentsLoading = false;
      state.commentsError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllDisputesThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllDisputesThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.disputes = action.payload;
      })
      .addCase(getAllDisputesThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(submitDisputeThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.submitSuccess = false;
      })
      .addCase(submitDisputeThunk.fulfilled, (state) => {
        state.loading = false;
        state.submitSuccess = true;
      })
      .addCase(submitDisputeThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.submitSuccess = false;
      })
      .addCase(getAllRaisedDisputesThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllRaisedDisputesThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.raisedDisputes = action.payload;
      })
      .addCase(getAllRaisedDisputesThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchDisputeCommentsThunk.pending, (state) => {
        state.commentsLoading = true;
        state.commentsError = null;
      })
      .addCase(fetchDisputeCommentsThunk.fulfilled, (state, action) => {
        state.commentsLoading = false;
        state.comments = action.payload;
      })
      .addCase(fetchDisputeCommentsThunk.rejected, (state, action) => {
        state.commentsLoading = false;
        state.commentsError = action.payload;
      })
      .addCase(postDisputeCommentThunk.fulfilled, (state, action) => {
        state.comments.push(action.payload?.value);
      })
      .addCase(createDisputeHierarchyThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createDisputeHierarchyThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.disputeHierarchyData.push(action.payload);
      })
      .addCase(createDisputeHierarchyThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchDisputeHierarchyAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDisputeHierarchyAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.disputeHierarchyData = action.payload;
      })
      .addCase(fetchDisputeHierarchyAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateDisputeHierarchyThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateDisputeHierarchyThunk.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.disputeHierarchyData.findIndex(
          (item) =>
            item.customerId === action.payload.customerId &&
            item.categoryId === action.payload.categoryId
        );
        if (index !== -1) {
          state.disputeHierarchyData[index] = action.payload;
        }
      })
      .addCase(updateDisputeHierarchyThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteDisputeHierarchyThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteDisputeHierarchyThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.disputeHierarchyData = state.disputeHierarchyData.filter(
          (item) =>
            item.customerId !== action.payload?.custId &&
            item.categoryId !== action.payload?.catId
        );
      })
      //  restict to raised disupte if hierarchy is not set
      .addCase(fetchDisputeHierarchyThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDisputeHierarchyThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.disputeHierarchy = action.payload;
      })
      .addCase(fetchDisputeHierarchyThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetSubmitSuccess, resetComments } = disputeSlice.actions;
export default disputeSlice.reducer;
